import { cloneDeep } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../mdae-framework";
const initialState = {
  currentBulkUpdateRows: [],
  currentSequenceNumber: 0,
  currentBulkUpdateConfigurationName: null,
  executeBulkUpdate: false,
  ignoreNoAdditionalRoundWarning: false,
};
export const TOGGLE_BULK_UPDATE_POPUP = "TOGGLE_BULK_UPDATE_POPUP";
export const ADD_BULK_UPDATE_ROW = "ADD_BULK_UPDATE_ROW";
export const UPDATE_BULK_UPDATE_ROW = "UPDATE_BULK_UPDATE_ROW";
export const UPDATE_BULK_UPDATE_ROW_USING_KEY = "UPDATE_BULK_UPDATE_ROW_USING_KEY";
export const REMOVE_BULK_UPDATE_ROW = "REMOVE_BULK_UPDATE_ROW";
export const RESET_BULK_UPDATE_ROWS = "RESET_BULK_UPDATE_ROWS";
export const EXECUTE_BULK_UPDATE = "EXECUTE_BULK_UPDATE";
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TOGGLE_BULK_UPDATE_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case ADD_BULK_UPDATE_ROW:
      newState = cloneDeep(state);
      newState.currentSequenceNumber += 1;
      newState.currentBulkUpdateRows.push({
        ...action.data,
        sequenceNumber: newState.currentSequenceNumber,
      });
      return newState;
    case RESET_BULK_UPDATE_ROWS:
      newState = cloneDeep(state);
      newState.currentSequenceNumber = 0;
      newState.currentBulkUpdateRows = [];
      return newState;
    case REMOVE_BULK_UPDATE_ROW:
      newState = cloneDeep(state);
      newState.currentBulkUpdateRows = newState.currentBulkUpdateRows.filter(
        (x) => x.sequenceNumber != action.data.sequenceNumber
      );
      for (let i = 0; i < newState.currentBulkUpdateRows.length; i++) {
        newState.currentBulkUpdateRows[i].sequenceNumber = i + 1;
      }
      newState.currentSequenceNumber = newState.currentBulkUpdateRows.length;
      return newState;
    case UPDATE_BULK_UPDATE_ROW:
      newState = cloneDeep(state);
      newState.currentBulkUpdateRows[action.data.sequenceNumber - 1] = {
        ...newState.currentBulkUpdateRows[action.data.sequenceNumber - 1],
        ...action.data,
      };
      return newState;
    case EXECUTE_BULK_UPDATE:
      return {
        ...state,
        executeBulkUpdate: action.data.executeBulkUpdate,
        ignoreNoAdditionalRoundWarning:
          action.data.ignoreNoAdditionalRoundWarning || false,
      };
    case UPDATE_BULK_UPDATE_ROW_USING_KEY:
      newState = cloneDeep(state);
      const bulkUpdateRow = newState.currentBulkUpdateRows.find(
        (x) => x.savePropertyName === action.data.savePropertyName
      );
      if (bulkUpdateRow) 
        bulkUpdateRow.fieldName = action.data.fieldName;
       else 
        newState.currentBulkUpdateRows.push({
          ...action.data,
          sequenceNumber: newState.currentSequenceNumber += 1,
        });
      
      return newState;

    default:
      return state;
  }
};
